import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';

export class ExcludedContentViewModel extends DrObject {

    model: Partial<ExcludedContent>;

    constructor(value?: Partial<ExcludedContent>) {
        super(DrObjectType.EXCLUDED_CONTENT);
        if (value) {
            this.model = value;
        }
    }
}


export class ExcludedContent extends DrEntity {
    createdBy: string;
    description: string;
    createdOn: string;
    emailSignatureText: string;
    name: string;
    handle: string;

    constructor(value?: Partial<ExcludedContent>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}
